"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var header_style_1 = require("./header-style");
var header_type_1 = require("./header-type");
var header_menu_1 = require("./menu/header-menu");
function Header(props) {
    var _a;
    var items = props.items, activeItemIndex = props.activeItemIndex, logoSource = props.logoSource, _b = props.logoType, logoType = _b === void 0 ? header_type_1.HeaderLogoType.TEXT : _b, onSelectItem = props.onSelectItem, restProps = __rest(props, ["items", "activeItemIndex", "logoSource", "logoType", "onSelectItem"]);
    var _c = (0, react_1.useState)(0), activeItemIndexState = _c[0], setActiveItemIndexState = _c[1];
    var _d = (0, react_1.useState)(0), activeSubItemIndex = _d[0], setActiveSubItemIndex = _d[1];
    function renderLogo() {
        if (logoType === header_type_1.HeaderLogoType.IMAGE) {
            return (0, jsx_runtime_1.jsx)(header_style_1.StyledHeaderLogoImage, { src: logoSource });
        }
        else if (logoType === header_type_1.HeaderLogoType.SVG) {
            return logoSource;
        }
        return (0, jsx_runtime_1.jsx)(header_style_1.StyledHeaderTitle, { children: logoSource });
    }
    return ((0, jsx_runtime_1.jsxs)(header_style_1.StyledHeader, __assign({}, restProps, { activeItem: (_a = items[activeItemIndex !== null && activeItemIndex !== void 0 ? activeItemIndex : activeItemIndexState]) === null || _a === void 0 ? void 0 : _a.item, children: [renderLogo(), (0, jsx_runtime_1.jsx)(header_menu_1.HeaderMenu, { items: items, activeItemIndex: activeItemIndex !== null && activeItemIndex !== void 0 ? activeItemIndex : activeItemIndexState, activeSubItemIndex: activeSubItemIndex, onSelectItem: function (index) {
                    setActiveItemIndexState(index);
                    setActiveSubItemIndex(0);
                    onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(index);
                }, onSelectSubItem: function (index) {
                    setActiveSubItemIndex(index);
                } })] })));
}
exports.Header = Header;
